import React from 'react'
import Heroo from '../../sections/Hero/Heroo'
import TrustedStrip from '../../sections/TrustedStrip/TrustedStrip'
import AISection from '../../sections/Aisection/Aisection'
import HowWeDriveOutcomes from '../../sections/HowWeDriveOutcomes/HowWeDriveOutcomes'
import OfferingSection from '../../sections/OfferingSection/OfferingSection'
import ProofSection from '../../sections/ProofSection/ProofSection'
import POVSection from '../../sections/POVSection/POVSection'
import FounderQuote from '../../sections/FounderQuote/FounderQuote'
import NextSection from '../../sections/NextSection/NextSection'

const Home = () => {
  return (
   <>
      <Heroo/>
      <TrustedStrip />
      <AISection/>
      <HowWeDriveOutcomes />
      <OfferingSection />
      <ProofSection />
      <POVSection />
      <FounderQuote />
      <NextSection />   
   
   </>
  )
}

export default Home